import { Helmet } from 'react-helmet-async'
import Section from '../components/common/Section'
import Gallery from '../components/gallery/Gallery'

// MIGRATION POINT: Data Fetching
// Current: Static JSON import in Gallery component
// Future: Replace with API call
// import artworks from '../data/artworks.json';
// const { data: artworks, isLoading } = useFetch('/api/artworks');
// Recommend: React Query for caching and loading states

export default function WerkePage() {
  return (
    <>
      <Helmet>
        <title>Werke - Gabriele Wiedemann</title>
        <meta
          name="description"
          content="Entdecken Sie die Kunstwerke von Gabriele Wiedemann - zeitgenössische Acrylmalerei."
        />
        <meta property="og:title" content="Werke - Gabriele Wiedemann" />
        <meta property="og:description" content="Galerie der zeitgenössischen Acrylmalerei" />
        <meta property="og:type" content="website" />
      </Helmet>

      <Section background="white" padding="large">
        <div className="max-w-7xl mx-auto">
          {/* Page Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-serif text-primary mb-4">Werke</h1>
            <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
              Eine Sammlung meiner Arbeiten in zeitgenössischer Acryl-Technik
            </p>
          </div>

          {/* Gallery Component */}
          <Gallery />
        </div>
      </Section>
    </>
  )
}
